// import { Auth } from "aws-amplify";
import * as Auth from "aws-amplify/auth";

// Checks Running Localhost
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][\\d]|[01]?[\\d][\\d]?)){3}$/
    )
);
const xApiKey = window.assureConfig?.apiHeaders["x-api-key"];

export const initLogin = async (callback) => {
  try {
    // * Check Current User Session & Validate user token
    const session = await getSessionHeaders();
    const authorization = session?.Authorization;
    if (!authorization) {
      callback();
    }
    callback({
      Authorization: authorization,
      xApiKey: xApiKey,
    });
  } catch (error) {
    console.error("error at init-login :>> ", error);
    return;
  }
};

export const login = async (username, password) => {
  try {
    const cognitoUser = await Auth.signIn({ username, password });
    const token = cognitoUser?.signInUserSession?.accessToken?.jwtToken;
    username && localStorage.setItem("username", username);
    return {
      Authorization: `Bearer ${token}`,
      xApiKey: xApiKey,
    };
  } catch (error) {
    console.error("error at login :>> ", error);
    return error;
  }
};

export const register = async (username, email, password) => {
  localStorage.clear();
  try {
    const { user } = await Auth.signUp({
      username,
      password,
      attributes: {
        // optional
        email, // phone_number, // E.164 number convention
      },
      autoSignIn: {
        // optional - enables auto sign in after user is confirmed
        enabled: true,
      },
    });
    // console.log('user :>> ', user);
    return user;
  } catch (error) {
    console.log("error at register :>> ", error);
  }
};

export const confirmSignUp = async (username, code) => {
  try {
    await Auth.confirmSignUp(username, code);
    username && localStorage.setItem("username", username);
  } catch (error) {
    console.log("error at confirmSignUp :>> ", error);
    return error;
  }
};

export const getUsername = () => {
  return localStorage.getItem("username") || "";
};

export const logOut = async () => {
  try {
    await Auth.signOut();
  } catch (error) {
    // ? Code to handle the exception
    console.error("Error at dev-central: signOut");
    console.log("error at logOut :>> ", error);
    localStorage.clear();
  } finally {
    // ? Code that will always be executed, whether there was an exception or not
    // ? Clean Storage, Before redirecting back to login path
    localStorage.clear();
  }
};

// ? Get User Token
const fetchAuthSession = async () => {
  try {
    // * Check Current User Session & Validate user token
    await Auth.getCurrentUser();
    // * Gets User Tokens ( idToken or accessToken )
    const session = await Auth.fetchAuthSession();
    const token = session?.tokens?.accessToken;
    return token;
  } catch (error) {
    throw error;
  }
};

export const getSessionHeaders = async () => {
  // ? For Testing
  if (window?.assureConfig?.enableAuthMocking) {
    return {};
  }

  // ? For Localhost Development
  if (isLocalhost && window?.assureConfig?.dev) {
    // * Declaration
    const username = window?.assureConfig?.username_dev;
    const password = window?.assureConfig?.password_dev;
    let _token;
    try {
      // ? Check Current Session
      _token = await fetchAuthSession();
    } catch (error) {
      if (!_token) {
        // * Sign-in to get _token
        const userData = await Auth.signIn({ username, password });
        console.log("UserData :>> ", userData);
        _token = await fetchAuthSession();
        console.log("_token :>> ", _token);
        username && localStorage.setItem("username", username);
      }
    }
    // Return Authorization
    return { Authorization: `Bearer ${_token}` };
  }

  // * For Production
  try {
    const token = await fetchAuthSession();
    return { Authorization: `Bearer ${token}` };
  } catch (err) {
    console.error("Error at getSessionHeaders :>> ", err);
  }
  return {};
};

export const checkUserAuthentication = async () => {
  try {
    await fetchAuthSession();
    return true;
  } catch (err) {
    console.error("Error checkUserAuthentication :>> ", err);
    const locationPath = window.location.href;
    window.location.href = `${window.location.origin}${window.assureConfig.loginPath}?redirectPath=${locationPath}`;
    return false;
  }
};
